module.exports = __webpack_public_path__ + "img/7.328cccd2.jpg";